import { Component, OnInit, Input } from '@angular/core';
import { ApiNavLink } from '../api-list-items.models';

@Component({
  selector: 'app-api-link-card',
  templateUrl: './api-link-card.component.html',
  styleUrls: ['./api-link-card.component.scss']
})
export class ApiLinkCardComponent implements OnInit {

  @Input() apiNavLink : ApiNavLink;
  @Input() allAPIsArePublic : boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
